module.exports = __webpack_public_path__ + "img/31b-indicadores-docs-mapa-pontos.41c5d82f.png";